import React, { Fragment, useState, useEffect, useCallback } from 'react';
import QRCode from 'qrcode.react';
import { useSelector, useDispatch } from 'react-redux';
import { MdContentCopy } from 'react-icons/md';
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
    InputGroup,
    InputGroupAddon
} from 'reactstrap';
// import components
import Page from '../components/Page';
import ButtonLoader from '../mycomponents/Layout/ButtonLoader';
// import lib
import toastAlert from '../lib/toastAlert';
import isEmpty from '../lib/isEmpty';
// import validation
import { tfaValid } from '../validation/auth.validation';
// import api
import { generate2fa, verify2fa } from '../api/admin';

const title = "Two Factor Authentication";

const FormPage = () => {

    // hooks
    const dispatch = useDispatch();
    // redux-state
    const { google2Fa, email, tfaStatus } = useSelector((state) => state?.profile);
    // state
    const [code, setCode] = useState('');
    const [touched, setTouched] = useState(false);
    const [loader, setLoader] = useState(false);
    const [errors, setErrors] = useState({});

    const handleSubmit = useCallback(async (e) => {
        e.preventDefault();
        try {
            setLoader(true)
            const { status, errors, message } = await verify2fa({ code }, dispatch);
            setLoader(false)
            if (status === true) {
                toastAlert('success', message, 'verify2fa');
                setCode('')
                setErrors({});
                setTouched(false);
            } else if (errors) {
                setErrors(errors)
            } else if (message) toastAlert('error', message, 'verify2fa')

        } catch (err) {
            // console.log(err, 'errrr')
        }
    }, [code, dispatch]);

    useEffect(() => {
        const { status, errors } = tfaValid({ code });
        if (!status) setErrors(errors);
        else setErrors({})
    }, [code])

    useEffect(() => {
        if (!tfaStatus) {
            generate2fa(dispatch)
        }
    }, [tfaStatus, dispatch]);

    return (
        <Page title={title} breadcrumbs={[{ name: title, active: true }]}>
            <Row>
                <Col>
                    <Card>
                        <CardHeader>{title}</CardHeader>
                        <CardBody>
                            <Form>
                                {
                                    !tfaStatus && (
                                        <Col xl={6} lg={12} md={12}>
                                            <FormGroup>
                                                <QRCode value={google2Fa?.uri?.replace('SecretKey', email)} size={256} />
                                            </FormGroup>
                                            <FormGroup>
                                                <Label for="exampleEmail">Secret Key</Label>
                                                <InputGroup>
                                                    <Input
                                                        type="text"
                                                        name="secretKey"
                                                        value={google2Fa?.secret}
                                                        disabled={true}
                                                    />
                                                    <InputGroupAddon addonType="append">
                                                        <Button onClick={() => {
                                                            navigator.clipboard.writeText(google2Fa?.secret)
                                                            toastAlert('success', 'copied!', 'navigator')
                                                        }}>
                                                            <MdContentCopy />
                                                        </Button>
                                                    </InputGroupAddon>
                                                </InputGroup>
                                            </FormGroup>
                                        </Col>
                                    )
                                }
                                <Col xl={6} lg={12} md={12}>
                                    <FormGroup>
                                        <Label for="exampleEmail">Code</Label>
                                        <Input
                                            type="text"
                                            name="code"
                                            value={code}
                                            onChange={({ target: { value } }) => setCode(value)}
                                            onBlur={() => setTouched(true)}
                                            valid={isEmpty(errors?.code)}
                                        />
                                        {touched && <span className='text-danger'>{errors.code}</span>}
                                    </FormGroup>
                                    <ButtonLoader
                                        spinnerSize="sm"
                                        loader={loader}
                                        color={!tfaStatus ? "secondary" : "danger"}
                                        text={!tfaStatus ? "Enable" : "Disable"}
                                        onClick={handleSubmit}
                                        disabled={!isEmpty(errors)}
                                    />
                                </Col>
                            </Form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Page>
    );
};

export default FormPage;